import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import hasanImg from '../static/hasanImg.jpeg';
import './WelcomeModal.css';

const WelcomeModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [location.pathname]);

  const closeModal = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal-content">
        <button className="close-button" onClick={closeModal}>×</button>
        <Link to="/currentopenings">
          <img src={hasanImg} alt="Welcome" className="modal-image cursor-pointer" />
        </Link>
        <div className="modal-actions">
          <Link to="/currentopenings" className="modal-link-button">
            View Current Openings
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;